import { Directive, TemplateRef, ViewContainerRef, Input } from '@angular/core';
import { Store } from '@ngrx/store';

import * as selectors from '../../store/reducers';

@Directive({ selector: '[hasRole]' })
export class RoleDirective {
  roles = [];
  userRoles: string[];

  sub: any;

  constructor(
    public store: Store<any>,
    private templateRef: TemplateRef<any>,
    private viewContainerRef: ViewContainerRef
  ) {
    this.sub = this.store
      .select(selectors.org.currentOrgRoles)
      .withLatestFrom(this.store.select(selectors.auth.getRoles))
      .map(roles => {
        let result = roles.reduce((prev, next) => prev.concat(next), []);
        this.userRoles = result;
        this._updateView();
      })
      .subscribe();
  }

  @Input()
  set hasRole(roles: any) {
    if (!roles) roles = [];
    if (!Array.isArray(roles)) roles = [roles];
    this.roles = roles;
    this._updateView();
  }

  private _checkRoles(roles) {
    if (!roles.length) return true;
    if (!this.userRoles) return false;
    for (let i = 0; i < roles.length; i++) {
      let role = roles[i];
      if (this.userRoles.includes(role)) {
        return true;
      }
    }
    return false;
  }

  private _updateView() {
    const hasRole = this._checkRoles(this.roles);
    this.viewContainerRef.clear();
    if (hasRole) {
      this.viewContainerRef.createEmbeddedView(this.templateRef);
    }
  }

  ngOnDestroy() {
    this.sub.unsubscribe();
  }
}
